module.exports = __webpack_public_path__ + "static/media/280317.f17ca430.png";